import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import createLink from "../../../../libs/createLink";

import {
    deleteForumComment,
    fetchForumComment,
    resetForumComment,
    updateForumComment
} from "../../../../creators/forums.comment";
import {deleteForumTopic} from "../../../../creators/forums.topic";
import {config} from "../../../../config";

import Icon from '../../../components/Icon';
import Avatar from '../../../components/Avatar';
import Report from '../../../components/Report';
import Alert from '../../../components/Alert';
import {Button} from "../../../components/Button";
import {Can} from "../../../../ability-context";
import Modal from "../../../components/Modal";
import DateSince from "../../../components/Date";
import Dropdown from "../../../components/Dropdown";
import EditComment from "./EditComment";
import DraftContentReader from "../../../components/editor/DraftContentReader";
import {reportForumComment} from "../../../../creators/report";
import _ from "lodash";
import {contentRawToText} from "../../../../libs/helper";
import UserByIp from "../../../components/UserByIp";

class Comment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleEdit: false,
            content: this.props.content || "",
            contentRaw: this.props.contentRaw,
            includeSign: this.props.useSign,
            followTopic: !!(this.props.currentUser && this.props._id && this.props.currentUser.follow && this.props.currentUser.follow.topics && this.props.currentUser.follow.topics.includes(this.props._id)),
            displayMessage: this.props.edit.displayMessage,
            reason: this.props.edit && (this.props.edit.reason || ""),
            currentIndexMedia: 0,
            toggleDisplayImage: false,
            title: this.props.title || "",
            tags: this.props.tags || [],
            poll: this.props.poll || {},
            toggleAlertDelete: false,
            toggleWarning: false,
            toggleAnswerBtn: false,
            toggleModalIp : false
        };

        this.editorRef = React.createRef();

        this.handleStatus = this.handleStatus.bind(this);
        this.deleteComment = this.deleteComment.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleReport = this.handleReport.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.contentRaw !== this.props.contentRaw){
            this.editorRef.current.updateContent(this.props.contentRaw);
        }
        if(prevState.toggleEdit !== this.state.toggleEdit && !this.state.toggleEdit){
            this.props.resetComment();
        }
    }

    componentWillUnmount() {
        this.props.resetForumComment();
    }

    handleStatus() {
        this.props.updateForumComment(this.props.forumId, this.props.topicId, this.props._id, {isApproved: !this.props.isApproved});
        // this.props.handleComments();
        this.setState({reason: ''})
    }

    deleteComment() {
        this.props.deleteForumComment(this.props.forumId, this.props.topicId, this.props._id);
        this.setState({toggleAlertDelete: false});
    }

    handleDelete() {
        if (this.props.isFirstPost) {
            this.props.deleteForumTopic(this.props.forumId, this.props.topicId);
        } else {
            this.deleteComment()
        }
    }

    handleReport(message){
        this.props.reportForumComment(this.props.forumId, this.props.topicId, this.props._id, {message});
    }

    handleClose(){
        this.props.resetForumComment();
        this.setState({toggleEdit: false});
    }

    render() {
        let hasOwner = this.props.owner !== null && this.props.owner._id;
        let checkGender = config.genderClass[hasOwner ? this.props.owner.profile.gender : 0];

        return (
            <div id={this.props._id} className={`answer-wrapper ${this.props.isApproved ? "" : "isHidden"}`}>
                <div id={this.props.isLastCommentPage ? "last-comment" : null} className={`answer-topline ${checkGender}`}>
                    <div className={"left-side"}>
                        {hasOwner ? (
                            <Link to={createLink("userProfile", this.props.owner)}>
                                <Avatar className="user-avatar" avatar={this.props.owner.profile.avatar}
                                        gender={this.props.owner.profile.gender} alt=""/>
                            </Link>
                        ) : (
                            <Avatar className="user-avatar" gender="guest" alt=""/>
                        )}
                        <div className={"user-information"}>
                            <span className={"username"}>
                                {hasOwner ? ( <Link to={createLink("userProfile", this.props.owner)}>{this.props.owner.username}</Link>) : (`Guest_${this.props.authorName}`)}
                                {hasOwner && (
                                    <div className={"more-informations"}>
                                        <Icon type={"question-circle"}/>
                                        <div className={"more-informations-wrapper"}>
                                            {this.props.owner && this.props.owner.createdAt && (
                                                <span className={"member-informations"}>
                                            Membre depuis :
                                            <DateSince
                                                date={this.props.owner.createdAt}
                                                prefix={false}
                                                currentFormat={false}
                                            />
                                        </span>
                                            )}

                                            <span className={"member-informations"}>Messages : {this.props.owner && this.props.owner.count && (this.props.owner.count.comment || 0)} </span>
                                            {this.props.owner && this.props.owner.location && this.props.owner.location.city && this.props.owner.location.city.name && this.props.owner.location.city.name.length && (
                                                <span
                                                    className={"member-informations"}>Localisation : {this.props.owner && this.props.owner.location.city.name}</span>
                                            )}
                                            {this.props.owner && this.props.owner.location && this.props.owner.location.city && this.props.owner.location.city.name && !this.props.owner.location.city.name.length && this.props.owner.location.country && this.props.owner.location.country.name && this.props.owner.location.country.name.length && (
                                                <span
                                                    className="member-informations">Localisation : {this.props.owner.location.country.name}</span>
                                            )}
                                        </div>
                                    </div>
                                )}

                            </span>
                            {hasOwner ? <span className={"role"}>{config.role[this.props.owner.role]}</span> : ""}
                        </div>
                    </div>
                    <div className={"right-side"}>
                        <Can action={"display-ip"} subject={this.props.currentUser} modelName="Topic">
                            <div className={"row"}>
                                <input type={"checkbox"} onClick={() => this.props.handleMultipleCheckbox(this.props._id)}  defaultChecked={this.props.multipleCheckbox.includes(this.props._id)}/>
                                <label className={"cursor-pointer"} onClick={()=>this.setState({toggleModalIp : true})}>{this.props.ip}</label>
                                <Modal toggle={this.state.toggleModalIp}
                                       handleClose={() => this.setState({toggleModalIp: false})}>
                                    <UserByIp ip={this.props.ip} handleClose={() => this.setState({toggleModalIp: false})} />
                                </Modal>
                            </div>
                        </Can>

                    </div>
                </div>
                <div className={"content"}>
                    <div className={"answer"}>
                        <DraftContentReader contentRaw={this.state.contentRaw} ref={this.editorRef} extendedProps={{
                            forumId : this.props.forumId,
                            topicId : this.props.topicId,
                            kind : "topicComments"
                        }}/>
                    </div>
                    {this.props.edit.displayMessage && (
                        <div className="modified">
                            <span><Icon
                                type="report"/> Modifié par {(this.props.edit && this.props.edit.owner && this.props.edit.owner.username) || "Guest"}, <DateSince
                                date={this.props.edit.updatedAt}
                                handleReport={this.handleReport}
                                prefix={true}
                                currentFormat={true}
                            /></span>
                            <span>{this.props.edit.reason}</span>
                        </div>
                    )}
                    {/*<div className="row attachement-container">*/}
                    {/*    {this.props.medias && this.props.medias.length >= 1 && this.props.medias.map((item, index) => {*/}
                    {/*        if (item.feature.ext === "jpeg" || item.feature.ext === "jpg" || item.feature.ext === "png") {*/}
                    {/*            return <div className="attachement-img" onClick={() => this.setState({*/}
                    {/*                currentIndexMedia: index,*/}
                    {/*                toggleDisplayImage: true*/}
                    {/*            })} style={{backgroundImage: `url(${item.filename.url})`}}></div>*/}
                    {/*        } else if (item.feature.ext === "pdf") {*/}
                    {/*            return <Link to="/">item.title</Link>*/}
                    {/*        } else return null;*/}
                    {/*    })}*/}
                    {/*    <Modal toggle={this.state.toggleDisplayImage}*/}
                    {/*           handleClose={() => this.setState({toggleDisplayImage: false})}>*/}
                    {/*        <DisplayImage*/}
                    {/*            currentIndex={this.state.currentIndexMedia}*/}
                    {/*            mediaAttachementArray={this.props.medias}*/}
                    {/*            handleClose={() => this.setState({toggleDisplayImage: false})}*/}
                    {/*        />*/}
                    {/*    </Modal>*/}
                    {/*</div>*/}

                    {!this.props.currentUser?.setting?.notDisplaySignatureInForum && this.props.useSign && _.get(this.props,"owner.setting.signature.contentRaw") && contentRawToText(this.props?.owner?.setting?.signature?.contentRaw).length !== 0 ? (
                        <div className="user-sign">
                            <DraftContentReader contentRaw={this.props.owner.setting.signature.contentRaw}/>
                        </div>
                    ) : null}
                </div>
                <div className={"answer-baseline"}>
                    <span className={"post-date"}>
                        Posté&nbsp;
                        <DateSince
                            date={this.props.createdAt}
                            prefix={true}
                            currentFormat={true}
                        />
                    </span>
                    <Can action={["moderation","report"]} subject={this.props} modelName="TopicComment">
                    <Button className={`responsive-btn-640 mt-8`}
                            size={"small"}
                            onClick={() => this.setState({toggleAnswerBtn: !this.state.toggleAnswerBtn})}
                            icon={"cog"}/>
                    </Can>
                    <div className={`right-side responsive-640 ${this.state.toggleAnswerBtn ? 'active' : ''}`}>
                        {this.props.currentUser && this.props.currentUser._id && (
                            <Fragment>
                                <Can action={["moderation","report"]} subject={this.props} modelName="TopicComment">
                                    <Dropdown align="top" activableComponent={(
                                        <Button size={"small"}
                                                btnStyle={"cancel-reverse"}
                                                content="Options de la réponse"/>
                                    )}>
                                        <ul className="dropdown-menu">
                                            <Can action={"update"} subject={this.props} modelName="TopicComment">
                                                <li className={"menu-item"} onClick={() => this.setState({toggleEdit: true})}>
                                                    <Icon type="pencil"/>
                                                    Modifier
                                                </li>
                                                <Modal toggle={this.state.toggleEdit}
                                                       handleClose={() => this.handleClose()}>
                                                    <EditComment handleClose={() => this.handleClose()}
                                                                 commentId={this.props._id}
                                                                 forumId={this.props.forumId}
                                                                 topicId={this.props.topicId} />
                                                </Modal>
                                            </Can>
                                            <Can action={"hide"} subject={this.props} modelName="TopicComment">
                                                <li className={"menu-item"} onClick={() => this.handleStatus()}>
                                                    <Icon type={this.props.isApproved ? `eye-cut` : `eye`}/>
                                                    {this.props.isApproved ? `Cacher` : `Afficher`}
                                                </li>
                                            </Can>
                                            <Can action={"delete"} subject={this.props} modelName="TopicComment">
                                                <li className={"menu-item"} onClick={() => this.setState({toggleAlertDelete: true})}>
                                                    <Icon type="trash"/>
                                                    Supprimer
                                                </li>
                                                <Modal toggle={this.state.toggleAlertDelete}
                                                       handleClose={() => this.setState({toggleAlertDelete: false})}>
                                                    <Alert text="Voulez-vous vraiment supprimer la réponse ?"
                                                           handleDelete={this.handleDelete}
                                                           handleClose={() => this.setState({toggleAlertDelete: false})}/>
                                                </Modal>
                                            </Can>
                                            <Can action={"report"} subject={this.props} modelName="TopicComment">
                                                <li className={"menu-item"}>
                                                    <Report _id={this.props._id}
                                                            kind={"topicComments"}
                                                            type={"comment"}
                                                            handleReport={this.handleReport}
                                                            title="le commentaire"/>

                                                </li>
                                            </Can>
                                        </ul>
                                    </Dropdown>
                                </Can>
                                <Can action={"quote"} subject={this.props} modelName="TopicComment">
                                    <Button className={"multi"}
                                            active={this.props.quotesIds.includes(this.props._id.toString())}
                                            size={"small"}
                                            btnStyle={"primary"}
                                            onClick={() => this.props.handleMultipleQuotes({
                                                _id: this.props._id,
                                            })}
                                            content={"Multi-citation"}/>
                                </Can>
                                <Can action={"quote"} subject={this.props} modelName="TopicComment">
                                    <Button size={"small"}
                                            btnStyle={"primary-reverse"}
                                            onClick={() => this.props.quote({
                                                _id: this.props._id,
                                            })}
                                            content="Citer"/>
                                </Can>
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

Comment.defaultProps = {
    owner: {
        slug: '',
        username: '',
        profile: {
            avatar: '',
            gender: 3,
            signature: {
                display: false,
                contentRaw: ''
            }
        },
        right: {
            name: '',
            right: {}
        }
    },
    edit: {
        name: '',
        reason: '',
    },
    editedAt: 0,
    contentRaw: '',
    createdAt: '',
    useSign: false

};

const mapStateToProps = (state) => {
    return {
        currentUser : state.currentUser.data,
        forumComment: state.forumComment.data,
        forumCommentLoading: state.forumComment.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForumComment,
    updateForumComment,
    deleteForumComment,
    resetForumComment,

    deleteForumTopic,
    reportForumComment,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Comment);